import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 600px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MobileWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${p => p.theme.app.padding.horizontal};

  .ant-steps-item-icon {
    height: 24px;
    width: 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      height: 12px;
      width: 12px;
    }
  }

  .ant-steps-item-tail {
    top: 8px;
    left: 0px;
  }

  .ant-steps-label-vertical .ant-steps-item-icon {
    margin-left: 46px;
  }
`;

export const TextStep = styled.span`
  font-size: ${props => props.theme.font.size.xs} !important;
  font-weight: ${props => props.theme.font.weight.bold};
  line-height: 12px !important;
`;

export const ContentStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  margin-bottom: 24px;
`;

export const ContentMobileStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  margin-bottom: 24px;

  #normal_login {
    width: 100% !important;
  }

  .ant-row {
    flex-direction: column;
  }
`;
